import { Component, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-printable-table-header",
  imports: [TranslateModule, DatePipe],
  templateUrl: "./printable-table-header.component.html",
  styleUrl: "./printable-table-header.component.scss",
})
export class PrintableTableHeaderComponent {
  title = input<string>();
  dateFrom = input<Date>();
  dateTo = input<Date>();

  today = new Date();
}
